import { registerPlugin } from '@capacitor/core';

import { isIOS } from 'utils/environment';

export interface ISalesforceInAppMessageActionPlugin {
  initialize: () => Promise<void>;
}

// at moment, this solution will be just to android
export const SalesforceInAppMessageActionPlugin = isIOS()
  ? null
  : registerPlugin<ISalesforceInAppMessageActionPlugin>('SalesforceInAppMessageActionPlugin');
